import { em } from 'polished'
import styled from 'styled-components'

import SectionWrapper from 'components/SectionWrapper'

export const ImageWrapper = styled.div`
  position: absolute;
  width: calc(100% + ${p => p.theme.indents.baseIndentXs} * 2);
  bottom: 0;
  left: -${p => p.theme.indents.baseIndentXs};

  ${p => p.theme.mq.upMd} {
    width: ${em(772)};
    left: ${em(30)};
    bottom: ${em(-215)};
  }

  ${p => p.theme.mq.upLg} {
    width: ${em(697)};
    left: auto;
    bottom: auto;
    top: ${em(-20)};
    right: ${em(-96)};
  }

  ${p => p.theme.mq.upXl} {
    right: 0;
  }
`

export const SectionWrapperStyled = styled(SectionWrapper)`
  background-color: ${p => p.theme.colors.purpleHeart};

  ${p => p.theme.mq.upLg} {
    height: ${em(547)};
  }
`

export const Col = styled.div`
  margin-bottom: 90vw;

  ${p => p.theme.mq.upMd} {
    margin-bottom: ${em(355)};
  }

  ${p => p.theme.mq.upLg} {
    margin-bottom: 0;
  }
`
